import {
  List,
  Datagrid,
  Edit,
  SimpleForm,
  TextField,
  // SelectInput,
  NumberInput,
  NumberField,
  Toolbar,
  SaveButton,
  BooleanField,
  // BooleanInput,
} from 'react-admin'


export const ServiceConfigList = () => (
  <List>
    <Datagrid rowClick='edit' bulkActionButtons={false}>
      <TextField source="updatedBy" />
      <NumberField source="inviterBonusPercentage" />
      <NumberField source="inviteeBonusPercentage" />
    </Datagrid>
  </List>
)

const CustomToolbar = () => (
  <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <SaveButton />
  </Toolbar>
)

export const ServiceConfigEdit = () => (
  <Edit>
    <SimpleForm toolbar={<CustomToolbar />}>
      <NumberInput source="inviterBonusPercentage" label="Inviter Bonus Percentage" />
      <NumberInput source="inviteeBonusPercentage" label="Invitee Bonus Percentage" />
    </SimpleForm>
  </Edit>
)
